import { useQuery } from 'react-query';
import { PROD_API } from '../constants/api';
import { BookStatisticsResponse } from '../types/statistics/bookStatistics';

const fetchBookStatistics = async (): Promise<BookStatisticsResponse> => {
  const authTokens = JSON.parse(localStorage.getItem('authTokens') as string);

  const response = await fetch(`${PROD_API}/api/users/premium_books_statistics`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authTokens.access}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch book statistics');
  }

  const data: BookStatisticsResponse = await response.json();

  if (!data.success) {
    throw new Error('Invalid response format');
  }

  return data;
};

export const useBookStatistics = () => {
  return useQuery<BookStatisticsResponse, Error>(
    'bookStatistics',
    fetchBookStatistics,
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
      retry: 2,
      onError: (error: Error) => {
        console.error('Error fetching book statistics:', error);
      },
    }
  );
};

